import { categories } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-configuration/categories';

export const Volume = {
  Volume: {
    subType: null,
    valueType: 'NUMBER',
    categories,
  },
};
